import { render, staticRenderFns } from "./EmployeeItem.vue?vue&type=template&id=74e4c370&scoped=true&"
import script from "./EmployeeItem.vue?vue&type=script&lang=ts&"
export * from "./EmployeeItem.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeItem.vue?vue&type=style&index=0&id=74e4c370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e4c370",
  null
  
)

export default component.exports